<template>
  <sc-render :fields="fields" :empty-message="$t('NO_DATA_SOURCE_EXIST')">
    <media-display
      class="media-display"
      :class="{ 'media-display--edit-mode': isEditMode }"
      :sc-image-field="desktopImageField"
      :video-source="videoUrl"
      :video-loop="loopVideo"
      :video-hidden-text="hiddenVideoTitle"
    >
      <picture>
        <source :srcset="mobileImageSrc" media="(max-width: 767px)">
        <img :src="desktopImageSrc" :alt="desktopImageAlt" />
      </picture>
    </media-display>
  </sc-render>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import get from '~/helpers/get'
  import mapFields from '~/helpers/map-fields'
  import MediaDisplay from '~/components/sitecore/media-display'
  import ScRender from '../sc-render'

  const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

  export default {
    name: 'EditorialFullImage',

    components: {
      ScRender,
      MediaDisplay
    },

    props: {
      fields: {
        type: Object,
        default: () => ({})
      }
    },

    computed: {
      ...mapJssGetters(['isEditMode']),
      ...mapFields({
        hiddenVideoTitle: 'hiddenVideoTitle.value',
        loopVideo: 'loop.value',
        mobileVideoUrl: 'mobileVideo.value',
        desktopVideoUrl: 'mainVideo.value'
      }),

      desktopImageField () {
        return get(this.fields, 'desktopImage')
      },

      mobileImageField () {
        return get(this.fields, 'mobileImage')
      },

      desktopImageValue () {
        return get(this.desktopImageField, 'value')
      },

      mobileImageValue () {
        return get(this.mobileImageField, 'value')
      },

      desktopImageSrc () {
        return get(this.desktopImageValue, 'cloudinary_4x3_fill_crop')
          || get(this.desktopImageValue, 'src', '')
      },

      mobileImageSrc () {
        return get(this.mobileImageValue, 'cloudinary_3x4_fill_crop')
          || get(this.mobileImageValue, 'src', '')
      },

      desktopImageAlt () {
        return get(this.desktopImageValue, 'alt', '')
      },

      videoUrl () {
        return this.$device.isMobile ? this.mobileVideoUrl : this.desktopVideoUrl
      }
    }
  }
</script>

<style lang="scss" scoped>
  .media-display {
    @include stack-space($space-090);

    @include tablet {
      @include stack-space($space-100);
    }

    &--edit-mode {
      text-align: center;

      ::v-deep img {
        max-width: 100%;
        height: auto;

        &.scEmptyImage {
          width: auto;
          margin: 0 auto;
        }
      }
    }
  }
</style>
